export const dbName = 'leaderrxdb';
export const dbVersion = 1;
